<template>
  <promise-wait :promise="promise" v-slot="slot" v-model="response" :transform="transform" v-on="$listeners"><slot v-bind="{reload, ...slot}" /></promise-wait>
</template>

<script>
/* eslint-disable indent */

import PromiseWait from './PromiseWait'

export default {
  name: 'Ajax',
  components: {
    PromiseWait
  },
  props: {
    url: {
      type: String,
      required: true
    },
    method: {
      type: String,
      default: 'get'
    },
    query: null,
    transform: {
      type: Function
    },
    catch: {
      type: Function,
      default: error => Promise.reject(error)
    }
  },
  data: function () {
    return {
      promise: null,
      response: null
    }
  },
  watch: {
    // url: {
    //   handler: function () {
    //     this.reload()
    //   },
    //   deep: true,
    //   immediate: true
    // },
    query: {
      handler: function () {
        this.reload()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    reload: function () {
      this.promise = this.$api[this.method](this.url, this.query).catch(this.catch)
    }
  }
}
</script>
